import { useState } from "react";
import { X, Save, Zap } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../api";

const STATUSES = ["Teklif", "Devam Ediyor", "Durduruldu", "Tamamlandı", "İptal Edildi"];
const TYPES = ["RES", "GES", "Depolamalı RES", "Depolamalı GES", "DGES", "HES", "Hibrit"];
const FIELDS = ["process_status", "project_type", "city", "district", "locality",
  "license_no", "capacity_production", "capacity_storage", "turbine_count"];

export default function MasterEditModal({ project, close, onSaved }) {
  const [form, setForm] = useState(() => Object.fromEntries(FIELDS.map((k) => [k, project[k] ?? ""])));
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = Object.fromEntries(FIELDS.map((k) => [k, (form[k] || "").trim() || null]));
      await api.put(`/projects/${project.id}/master`, payload);
      toast.success("Künye güncellendi");
      onSaved?.(); close();
    } catch (err) { toast.error(errMsg(err, "Kaydedilemedi")); }
    finally { setSaving(false); }
  };

  return (
    <div className="modal-backdrop" onClick={close}>
      <form className="modal modal-wide" onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="master-edit-modal">
        <div className="modal-head">
          <div><span className="eyebrow">TEKNİK & LİSANS</span><h2>{project.name} · Künye</h2></div>
          <button type="button" onClick={close} data-testid="master-close-button"><X size={18} /></button>
        </div>
        <div className="form-grid">
          <label>Durum
            <select value={form.process_status} onChange={set("process_status")} data-testid="master-status-select">
              <option value="">Seçin…</option>
              {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </label>
          <label>Tür
            <input list="master-types" value={form.project_type} onChange={set("project_type")} placeholder="Depolamalı RES" data-testid="master-type-input" />
            <datalist id="master-types">{TYPES.map((t) => <option key={t} value={t} />)}</datalist>
          </label>
          <label>İl<input value={form.city} onChange={set("city")} placeholder="İzmir" data-testid="master-city-input" /></label>
          <label>İlçe<input value={form.district} onChange={set("district")} data-testid="master-district-input" /></label>
          <label>Mahalle / Köy<input value={form.locality} onChange={set("locality")} data-testid="master-locality-input" /></label>
          <label>Türbin Sayısı<input value={form.turbine_count} onChange={set("turbine_count")} data-testid="master-turbine-input" /></label>
          <label className="full-w"><span className="lbl-ico"><Zap size={12} /> Üretim Tesisi Kapasitesi</span><input value={form.capacity_production} onChange={set("capacity_production")} placeholder="32 MWm/22,5 MWe" data-testid="master-capprod-input" /></label>
          <label className="full-w"><span className="lbl-ico"><Zap size={12} /> Depolama Tesisi Kapasitesi</span><input value={form.capacity_storage} onChange={set("capacity_storage")} placeholder="22,5 MWe/22,5 MWh" data-testid="master-capstor-input" /></label>
          <label>Lisans Bilgisi<input value={form.license_no} onChange={set("license_no")} placeholder="ÖN/11891-16/05575" data-testid="master-license-input" /></label>
        </div>
        <button type="submit" className="new-btn full" disabled={saving} data-testid="master-save-button"><Save size={15} /> {saving ? "Kaydediliyor…" : "Künyeyi Kaydet"}</button>
      </form>
    </div>
  );
}
